import { Component, DestroyRef, inject, Inject, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { APP_CONFIG } from '../../../../app.config';
import { AssistantPopoverService } from '../../../../common/assistant-popover.service';
import { getRequestLandWithRegExForPostalCode } from '../../../../common/factory/form.default.factory';
import { FormService } from '../../../../common/form.service';
import { ValidationService } from '../../../../common/validation.service';
import { leapDayValidator } from '../../../../common/validators';
import { ValueListsService } from '../../../../common/value-lists.service';
import { loadValueLists, ValueList } from '../../../../common/valueListHelper';
import { AppConfig } from '../../../../models/config/app-config';
import { ValueListItem } from '../../../../models/rest/valuelist/valuelist';
import { VisumErfassungSubFormComponent } from '../../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-organisation',
  templateUrl: './organisation.component.html',
  styleUrls: ['./organisation.component.scss']
})
export class OrganisationComponent extends VisumErfassungSubFormComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription = new Subscription();
  landListItems: ValueListItem[];
  staatsangehoerigkeitListItems: ValueListItem[];
  geschlechtListItems: ValueListItem[];
  registerListItems: ValueListItem[];
  wirkungsbereichListItems: ValueListItem[];
  private readonly destroyRef = inject(DestroyRef);

  constructor(formBuilder: FormBuilder,
              assistantPopoverService: AssistantPopoverService,
              private valueListsService: ValueListsService,
              private validationService: ValidationService,
              private formService: FormService,
              @Inject(APP_CONFIG) public appConfig: AppConfig,
              @Optional() @Self() controlDir: NgControl) {
    super(controlDir, assistantPopoverService);

    // Initialize form
    this.form = formBuilder.group({

      // Organistation/ Bildungseinrichtung
      orgaName: [null, validationService.getValidators('referenz.organisation.name')],
      orgaSitz: [null, validationService.getValidators('referenz.organisation.sitz')],
      orgaSitzLand: [null, validationService.getValidators('referenz.organisation.land')],
      orgaAufgabe: [null, validationService.getValidators('referenz.organisation.wirkungsbereich')],
      orgaRegisterName: [null, validationService.getValidators('referenz.organisation.registerName')],
      orgaRegisterOrt: [null, validationService.getValidators('referenz.organisation.registerOrt')],
      orgaRegisternummer: [null, validationService.getValidators('referenz.organisation.registerNummer')],

      // Person
      familienname: [null, validationService.getValidatorsAndRequired('referenz.ansprechpartner.familienname')],
      vorname: [null, validationService.getValidatorsAndRequired('referenz.ansprechpartner.vorname')],
      geschlecht: [null, validationService.getValidators('referenz.ansprechpartner.geschlecht')],
      geburtsdatum: [null, [...validationService.getValidators('referenz.ansprechpartner.geburtsdatum'), leapDayValidator]],
      staatsangehoerigkeit: [null, validationService.getValidators('referenz.ansprechpartner.staatsangehoerigkeit')],
      strasse: [null, validationService.getValidators('referenz.ansprechpartner.anschrift.strasse')],
      hausnummer: [null, validationService.getValidators('referenz.ansprechpartner.anschrift.hausnummer')],
      plz: [null, validationService.getValidators('referenz.ansprechpartner.anschrift.plz')],
      ort: [null, validationService.getValidators('referenz.ansprechpartner.anschrift.ort')],
      land: [null, validationService.getValidators('referenz.ansprechpartner.anschrift.land')],
      telefon: [null, validationService.getValidators('referenz.ansprechpartner.kontaktdaten.telefon')],
      email: [null, validationService.getValidators('referenz.ansprechpartner.kontaktdaten.email', false, true)]
    });
  }

  ngOnInit() {

    // This call is required to enable the status bar validation
    super.ngOnInit();

    const valueLists: ValueList[] = [
      { name: 'land', property: 'landListItems' },
      { name: 'staatsangehoerigkeit', property: 'staatsangehoerigkeitListItems' },
      { name: 'geschlecht', property: 'geschlechtListItems' },
      { name: 'organisation_register', property: 'registerListItems' },
      { name: 'organisation_wirkungsbereich', property: 'wirkungsbereichListItems' },
    ];

    loadValueLists(this.valueListsService, valueLists, this, this.subscriptions);

    if (this.appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT') {
      this.formService.initControlWithDefaultValueAndSetRegExBasedOnValueToAnother(getRequestLandWithRegExForPostalCode(this.form, this.destroyRef));
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
